import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort } from "@nosto/preact"
import { sortOptions } from "../config"
import Select from "./elements/Select"

export default function Toolbar({ toggleSidebar }) {
    const { response, pageType } = useAppState();
    const { activeSort, setSort } = useSort(sortOptions);
    const selectedFiltersCount = useSelectedFiltersCount();

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const docCount = response.products?.total ?? 0
    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    return (
        <div className="flex flex-col lg:flex-row items-center px-6 lg:px-[30px] py-4 lg:py-6">
            <div className="flex-1"></div>
            <div className="flex items-center w-full lg:w-auto">
                
                <div className="relative inline-block">
                    <Select
                        value={activeSort}
                        onChange={e => handleSortChange(e)}
                        className="ns-sort !px-2 !w-[180px]"
                        options={options}
                    />
                </div>
                
                <div className="flex-1 lg:flex-none flex items-center justify-end lg:justify-start">
                    <div className="lg:pr-4">
                        <button
                            className="flex items-center gap-2 px-3"
                            type="button"
                            aria-label="Open filters"
                            onClick={toggleSidebar}
                        >
                            <svg aria-hidden="true" focusable="false" role="presentation" width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.5 6L2.5 6.00063" stroke="currentColor"></path><path d="M5.5 8V4" stroke="currentColor"></path><path d="M13.5 14V10" stroke="currentColor"></path><path d="M16.5 12L2.5 12.0006" stroke="currentColor"></path>
                            </svg>
                            <span className="text-xs">Filters</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
